<template>
  <component :is="name"></component>
  <!-- <companyCn v-if="!funcView.partner_company_simple"></companyCn>
  <companyUs v-else></companyUs> -->
</template>

<script>
import companyCn from './children/serviceCompany_cn.vue';
import companyUs from './children/serviceCompany_us.vue';

export default {
  name: 'serviceCompany', // factory
  components: { companyCn, companyUs },
  data() {
    return {
      name: ''
    };
  },
  mounted() {
    // ocr识别 简版权限全在总部上管理
    this.getFuncView(null, () => {
      if (this.funcView.partner_company_simple) {
        this.name = 'companyUs';
      } else {
        this.name = 'companyCn';
      }
    });
  }
};
</script>

